import { ApiResponse, AxiosErrorCustom, axiosInstance } from '@/lib/axios';
import { TypedMutationConfig } from '@/lib/react-query';
import { useMutation } from '@tanstack/react-query';
import { z } from 'zod';
import { TColumn } from '../types/column.type';

export const DeleteColumnValidationSchema = z.object({
  spaceColumnId: z.string({ message: 'Space Column ID is required' }).min(1),
});
export type TDeleteColumnValidation = z.infer<typeof DeleteColumnValidationSchema>;
export type TDeleteColumnPayload = TDeleteColumnValidation;
export type TDeleteColumnResponse = ApiResponse<TColumn>;

export const deleteColumn = (payload: TDeleteColumnPayload): Promise<TDeleteColumnResponse> => {
  const url = `/space-column/${payload.spaceColumnId}`;

  return axiosInstance.delete(url);
};

/**
 * Use Delete Column React-Query Hook
 */
type UseDeleteColumnMutationOptions = {
  mutationConfig?: TypedMutationConfig<typeof deleteColumn, AxiosErrorCustom>;
};

export const useDeleteColumnMutation = ({ mutationConfig }: UseDeleteColumnMutationOptions) => {
  const { ...restConfig } = mutationConfig ?? {};

  return useMutation({
    mutationFn: deleteColumn,
    ...restConfig,
  });
};
